import axiosInstance from "@/config/axiosInstance";
import { getCMSApiRoute } from "@/helpers/api.util";

export async function getContentSuggestions({
  slug,
  limit = 20,
  includeReasons = true,
  signal,
}) {
  const response = await axiosInstance.get(
    getCMSApiRoute(`content/${encodeURIComponent(slug)}/suggestions`),
    { params: { limit, includeReasons }, signal }
  );
  const data = response.data?.data;

  if (!data || !Array.isArray(data.results)) {
    throw new Error("Invalid content suggestions response");
  }

  // Keep CMS ranking, card fields and future reason codes intact.
  return data;
}
